import { RequestService } from 'Utils/Api';
import { logger } from 'Utils/Logger';
import { getDefaultConfig } from 'Utils/Store';

/* 
DPP is Fox's own CMS
QA: https://qa1.dpp.foxcpe.com
Int: https://int1.dpp.foxcpe.com (not for SKUs)
(No Staging)
Prod: https://prod1.dpp.foxcpe.com
*/

export const getDppContent = async (name) => {
  const { foxApi, accountApiKey } = getDefaultConfig();
  const url = `${foxApi}/screens/${name}`;
  try {
    logger.apiRequest('getDppContent', url);
    const { data } = await RequestService.send({
      url,
      method: 'GET',
      customHeaders: { 'x-api-key': accountApiKey },
    });
    logger.apiResponse('getDPPContent', data);
    return data && data.panels ? data.panels.member : [];
  } catch (error) {
    logger.apiError('getDPPContent', url, error);
    return [];
  }
};

/* See https://teamfox.atlassian.net/wiki/spaces/DCGAS/pages/230686972/Managing+SKU+Copy+Images+and+Availability
for documentation on SKU info in DPP */
export const getSingleDppSku = async (planId) => {
  const { foxQaDppApi, foxApi, accountApiKey } = getDefaultConfig();
  //We are not maintaing the SKUs in int DPP, so using QA instead when on Int Env.
  const api = foxQaDppApi || foxApi;
  const url = `${api}/v1/natcomsku/plans/${planId}`;
  try {
    logger.apiRequest('getSingleDppSku', url);
    const { data } = await RequestService.send({
      url,
      method: 'GET',
      customHeaders: { 'x-api-key': accountApiKey },
    });
    logger.apiResponse('getSingleDppSku', data);
    return data;
  } catch (error) {
    logger.apiError('getSingleDppSku', url, error);
    return {};
  }
};

export const getDppSkus = async (planIds = []) => {
  try {
    logger.apiRequest('getDppSkus');
    const data = await Promise.all(planIds.map(async (planIds) => await getSingleDppSku(planIds)));
    logger.apiResponse('getDppSkus', data);
    return data;
  } catch (error) {
    logger.apiError('getDppSkus', error);
    return [];
  }
};

//see getUserType in utils/Dpp.js
export const getDppSkusByUserType = async (userType = '') => {
  const { foxQaDppApi, foxApi, accountApiKey } = getDefaultConfig();
  //We are not maintaing the SKUs in int DPP, so using QA instead when on Int Env.
  const api = foxQaDppApi || foxApi;
  const url = `${api}/v1/natcomsku/plans/userType/${userType}`;
  try {
    logger.apiRequest('getDppSkusByUserType', url);
    const { data } = await RequestService.send({
      url,
      method: 'GET',
      customHeaders: { 'x-api-key': accountApiKey },
    });
    logger.apiResponse('getDppSkusByUserType', data);
    return data;
  } catch (error) {
    logger.apiError('getDppSkusByUserType', url, error);
    return {};
  }
};
